import { r as renderDOMHead$1 } from './shared/unhead.pv34ME7O.mjs';
export { c as createDomRenderer } from './shared/unhead.pv34ME7O.mjs';
export { c as createHead } from './shared/unhead.YnmwhfIN.mjs';
import './shared/unhead.fg-0ge_u.mjs';
import './shared/unhead.DiRbsb3I.mjs';
import './shared/unhead.DvIxXxuO.mjs';
import 'hookable';
import './shared/unhead.CfgPMHXt.mjs';

function createDebouncedFn(callee, delayer) {
  let ctxId = 0;
  return () => {
    const delayFnCtxId = ++ctxId;
    delayer(() => {
      if (ctxId === delayFnCtxId) {
        callee();
      }
    });
  };
}

function renderDOMHead(head, options) {
  return renderDOMHead$1(head, options);
}

export { createDebouncedFn, renderDOMHead };
